import { Box } from '@mui/material';
import AlertLogoIMG from 'assets/images/AlertGroup.png';
// import Group from 'assets/images/Group.png';
// import { AlertLogoStyle, TextSpace, TextStyle } from './styles';
const AlertLogo = (props) => {
    const { position } = props;
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                minHeight: '10vh',
                backgroundColor: '#722C1B',
                bottom: '0',
                zIndex: '5',
                position: 'absolute'
            }}
        >
            <Box
                sx={{
                    width: 'calc(100% - 30px)',
                    minHeight: '10vh',
                    paddingLeft: '15px',
                    paddingRight: '15px',
                    backgroundImage: `url(${AlertLogoIMG})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat'
                }}
            />
        </Box>
        // <Box sx={AlertLogoStyle(`${window.innerHeight > 910 ? 'flex-start' : 'center'}`)}>
        //     <Box className="main-container">
        //         <Typography sx={TextStyle}>禁</Typography>
        //         <Typography sx={TextStyle}>止</Typography>
        //         <Typography sx={TextStyle}>酒</Typography>
        //         <Typography sx={TextStyle}>駕</Typography>
        //         <Typography component="img" src={Group} sx={TextStyle}></Typography>
        //         <Typography sx={TextStyle}>安</Typography>
        //         <Typography sx={TextStyle}>全</Typography>
        //         <Typography sx={TextStyle}>誠</Typography>
        //         <Typography sx={TextStyle}>無</Typography>
        //         <Typography sx={TextStyle}>價</Typography>
        //         <Typography sx={TextSpace}> </Typography>
        //         <Typography sx={TextStyle}>酒</Typography>
        //         <Typography sx={TextStyle}>後</Typography>
        //         <Typography sx={TextStyle}>找</Typography>
        //         <Typography sx={TextStyle}>代</Typography>
        //         <Typography sx={TextStyle}>駕</Typography>
        //     </Box>
        // </Box>
    );
};
export default AlertLogo;
